import { API_PATHS } from "../../config/ApiPaths";

export const apiRevenueBicagame = (stateDate, endDate) => {
  return `${API_PATHS.bicagame}?startDate=${stateDate}&endDate=${endDate}`;
};

